export const INIT_FILTER_FIELDS = {
    spaceTypeId: 0,
    activityId: "",
    studentId: "",
    campusId: 0,
    date: -1,
    //campusId: 1,
    //date: 1714021200000
};
export const FILTER_STYLE_PROPS = {
    CUSTOM_SELECT: {
        width: {
            container: "250px",
            containerSelect: "100%"
        },
        minWidth: "200px"
    },
    CUSTOM_BUTTON: {
        width: "95px",
        size: "small"
    }
};